module.exports = __webpack_public_path__ + "img/hydrophone-default.9b67eee5.svg";